import {
  UrlParamTypes,
  useDxpPreviewParam,
  useWidgetContext,
  usePlatformConfig,
} from '@dxp-module/common'
import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

const useBackClickHandler = (useRouterNavigate?: boolean) => {
  const {
    configuration: { spcUrl },
  } = useWidgetContext()
  const previewSearchParam = useDxpPreviewParam()
  const navigate = useNavigate()

  const referrer = useMemo(
    () =>
      document.referrer.includes(UrlParamTypes.DXP_PREVIEW)
        ? document.referrer
        : previewSearchParam
        ? `${document.referrer}${
            document.referrer.includes('?') ? '&' : '?'
          }${previewSearchParam}`
        : document.referrer,
    [previewSearchParam]
  )

  const configuratorUrl = useMemo(
    () => (previewSearchParam ? `${spcUrl}?${previewSearchParam}` : spcUrl),
    [previewSearchParam, spcUrl]
  )

  const {
    platformConfig: {
      myAccount: { backLinkRedirect },
    },
  } = usePlatformConfig()

  return useCallback(() => {
    if (backLinkRedirect) {
      window.location.assign(backLinkRedirect)

      return
    }

    if (configuratorUrl) {
      useRouterNavigate
        ? navigate(referrer || configuratorUrl)
        : window.location.assign(referrer || configuratorUrl)
    }
  }, [configuratorUrl, navigate, referrer, useRouterNavigate, backLinkRedirect])
}
export default useBackClickHandler
